import { Card, Col, List, Row, Typography } from "antd";
import { useLottie } from "lottie-react";
import animationData from "../../assets/json/Era.json";

const { Title } = Typography;

export const HomePage = ({ handleQuestionSubmitted, className, data }) => {
  const options = {
    animationData: animationData,
    loop: true,
  };

  const { View, setSpeed } = useLottie(options, {
    width: "inherit",
    height: "13vh",
  });
  setSpeed(3);
  

  return (
    <div className="homepage">
      <Row align="middle" className="logo-show-home">
        <Col>
          <Row align="middle">
            <Col span={12}>{View}</Col>
            <Col span={12}>
              <Title className="logo-era-text">ERA</Title>
            </Col>
          </Row>
          <Row justify={"center"}>
            <Title level={3} className="logo-subtitle-text">
              Easebuzz Rapid Assist
            </Title>
          </Row>
        </Col>
      </Row>
      <Row justify={"center"}>
        <ListCards
          data={data}
          handleQuestionSubmitted={handleQuestionSubmitted}
        />
      </Row>
    </div>
  );
};

const ListCards = ({ data, handleQuestionSubmitted, className }) => {
  const gutterSize = data.length <= 3 ? 58 : 16;
  return (
    <List
      grid={{
        gutter: gutterSize,
        xs: 1,
        sm: Math.min(2, data.length),
        md: Math.min(3, data.length),
        lg: Math.min(4, data.length),
        xl: Math.min(4, data.length),
        xxl: Math.min(4, data.length),
      }}
      className={className}
      dataSource={data}
      renderItem={(item) => (
        <List.Item className="list-cards">
          <Card
            className="questions-cards"
            onClick={() => handleQuestionSubmitted(item.question)}
          >
            <div className="card-content">
            <p className="questions-cards-text">{item.question}</p>
            <img
              className="questions-cards-img"
              alt={`${item.question}-img`}
              src={item.image}
            />
            </div>
          </Card>
        </List.Item>
      )}
    />
  );
};
